<div>
  <appMetadataWidget [data]="data"></appMetadataWidget>
  <app-metadata-field [data]="data"></app-metadata-field>
  <!-- <appMetadataInput [data]="data"></appMetadataInput> -->
  <div class="metadata-block" [formGroup]="form" id="form">
    <!-- <div>
      <div class="metadata-key">Key:</div>
      <div class="metadata-value">{{ data.key }}</div>
    </div> -->
    <div fxLayout="row wrap">
      <label for="label" class="widget-attr ml-0" title="{{ data.id }}">Label</label>
      &nbsp;
      <input formControlName="heading" class="widget-attr" id="label" type="text" placeholder="{{ data.label }}"/>
      <div *ngIf="form?.get('heading')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>
      <label class="widget-attr" for="desc">Description</label> &nbsp;
      <input class="widget-attr" formControlName="description" id="desc" type="text" [(ngModel)]="data.description" />
      <div *ngIf="form?.get('description')?.hasError('maxlength')" class="error-msg">Max 100 characters are allowed</div>
    </div>

    <br/>

    <!-- label (Ex. "Building number:")
prefix1 (Ex. "#")
input1 (numeric, integer=not decimal, min=0, max=input2)
prefix2 (Ex. "of")
input2 (numeric, integer, min=0, max=max).
max -->


    <div fxLayout="row wrap">
    
      <label for="prefix" class="widget-attr ml-0" >Prefix</label>&nbsp;
      <input formControlName="prefix" class="widget-attr" id="prefix" type="text" placeholder="Prefix"/>
      <label class="widget-attr" for="input1">Input 1</label> &nbsp;
      <input formControlName="obtainedInput"  type="number" id="input1" placeholder="Description"/>
    </div>
    <br/> 
    <div fxLayout="row wrap">
      <label for="middlePrefix" class="widget-attr ml-0">Prefix2</label>&nbsp;
      <input formControlName="middlePrefix" id="middlePrefix" class="widget-attr" type="text" placeholder="middlePrefix"/>
      <label class="widget-attr" for="desc">Input 2</label> &nbsp;
      <input formControlName="total" id="total" type="number" placeholder="Total"/>
    </div>
    <br/>
    <div fxLayout="row wrap">
      <label for="suffix" class="widget-attr ml-0" >Max</label>&nbsp;
      <input formControlName="suffix" class="widget-attr" type="text" placeholder="Suffix"/>
    </div>
</div>